/* 🤖 this file was generated by svg-to-ts */
export const matIconPlayCircleOutline: {
  name: 'play-circle-outline';
  data: string;
} = {
  name: 'play-circle-outline',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m10 16.5 6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`
};
